<!-- notification.component.html -->
<div *ngIf="showBanner" class="notification-banner" [class.blocked]="isPermissionBlocked()">
  <div class="banner-content">
    <div *ngIf="!isPermissionBlocked(); else blockedMessage">
      <div class="message">
        <div class="notification-icon">🔔</div>
        <div>
          <!-- <p>{{window}}</p> -->
          <!-- <p>{{conter}}</p>
          <p>{{debug}}</p> -->
          <h3>Enable Notifications!</h3>
          <p>To receive our latest offers and order updates instantly, please allow notifications.
Without enabling notifications, you may not be able to complete your order.</p>
        </div>
      </div>
      <div class="actions mt-2">
        <button class="btn secondary" (click)="dismissBanner()">Not now</button>
        <button class="btn primary" (click)="enableNotifications()" [disabled]="isRequesting">
          <span *ngIf="isRequesting" class="spinner me-2"></span>
          <span>Allow</span>
        </button>
      </div>
    </div>

    <ng-template #blockedMessage>
      <div class="message">
        <div class="warning-icon">⚠️</div>
        <div>
          <h3>Notifications blocked</h3>
          <p>To enable, update your browser settings:</p>
          <ol class="steps">
            <li>Click <strong>🔒 Lock icon</strong> in address bar</li>
            <li>Select <strong>Site settings</strong></li>
            <li>Change <strong>Notifications</strong> to Allow</li>
          </ol>
        </div>
      </div>
      <div class="actions">
        <button class="btn" (click)="dismissBanner()">Got it</button>
        <button class="btn" (click)="reloadPage()">Refresh</button>
      </div>
    </ng-template>
  </div>
</div>